import React from "react";
import { Spinner } from "react-bootstrap";

import "./styles.css";

function SpinnerButton(props) {
  const { onClick, className, text, disabled, loading } = props;
  return (
    <button
      onClick={loading ? () => {} : onClick}
      className={!loading ? className : "btnStyle"}
      disabled={disabled}
      style={{ opacity: disabled ? 0.3 : 1 }}
    >
      {!loading ? (
        <>{text}</>
      ) : (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      )}
    </button>
  );
}
export default React.memo(SpinnerButton);
